// extracted by mini-css-extract-plugin
export default {"gap":"poster-editor-item-date-styles-panel-module__gap--UIPXO"};